import ReactDOM from 'react-dom/client';
import React from 'react';
import { ToastContainer } from 'react-toastify';
import { FeaturedProducts } from './featured-products';
import { v2Component } from '../../..';
import { TenantContext } from '../../../context/tenant-context';

export function initFeaturedProductsV2() {
  document.getElementsByName('featured-products-v2').forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);
      const { tenant, contextPath, locationId, userId, sessionId, isUserLoggedIn, ...props } = Object.assign(
        {},
        element.dataset,
      ) as any;
      root.render(
        v2Component(
          <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
            <ToastContainer />
            <FeaturedProducts
              locationId={locationId}
              user={{ userId: userId ? userId : undefined, sessionId, isLoggedIn: isUserLoggedIn === '1' }}
              {...props}
            />
          </TenantContext.Provider>,
        ),
      );

      const event = new CustomEvent('change');
      element.dispatchEvent(event);
    }
  });
}
